import React, { useCallback } from 'react';
import style from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Palette } from 'core/config';

interface Props 
{
    content        : string;
    hyperlink?     : string;
    hyperlinkHref? : string;
    css?           : string;
}

export const CardError : React.FunctionComponent<Props> = ({ 
    content, 
    hyperlink, 
    hyperlinkHref, 
    css 
}) =>
{
    const history = useHistory();

    const href = useCallback(() => 
    {
        hyperlinkHref && history.push(hyperlinkHref);
    }, [ history, hyperlinkHref ]);

    return (
        <Container css={css}>
            <ErrorMessage>
                {content}
                {hyperlink && (
                    <Hyperlink onClick={href}>
                        {hyperlink}
                    </Hyperlink>
                )}
            </ErrorMessage>
        </Container>
    );
};

const Container = style.div<{ css? : string; }>`
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-left: 60px;
    margin-right: 60px;
    width: 299px;
    
    ${props => props.css && props.css};
`;

const ErrorMessage = style.div`
    font: normal normal normal 10px 'SofiaPro-Regular';

    @media only screen and (min-width: 1300px) {
        font-size: 12px;
    }

    @media only screen and (min-width: 1900px) {
        font-size: 14px;
    }

    color: ${Palette.BLUE};
    text-align: center;
    border: 1px solid #E07A5F;
    border-radius: 11px;

    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 17.5px;
    padding-right: 17.5px;
`;

const Hyperlink = style.span`
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
`;